import React, { useState } from 'react';
import { ChromePicker, RGBColor } from 'react-color';

import './ColorPicker.scss';

type ColorPickerProps = {
    onColorChange: (color: string) => void;
    disabled?: boolean;
};

export const ColorPicker: React.FC<ColorPickerProps> = ({ onColorChange, disabled = false }) => {
    const [isPickerVisible, setIsPickerVisible] = useState(false);
    const [pickerColor, setPickerColor] = useState<RGBColor>({
        r: 0,
        g: 0,
        b: 0,
        a: 1,
    });

    return (
        <div className="color-picker">
            <button onClick={() => setIsPickerVisible(!isPickerVisible)} disabled={disabled}>
                <span
                    className="background-color"
                    style={{
                        backgroundColor: `rgba(${pickerColor.r},${pickerColor.g},${pickerColor.b},${pickerColor.a})`,
                    }}
                />
                Background
            </button>
            {isPickerVisible && (
                <>
                    <div className="picker-backdrop" onClick={() => setIsPickerVisible(false)} />
                    <div className="color-picker-widget">
                        <ChromePicker
                            color={pickerColor}
                            onChange={(color) => {
                                const { r, g, b, a } = color.rgb;
                                setPickerColor(color.rgb);
                                onColorChange(`rgba(${r},${g},${b},${a})`);
                            }}
                        />
                    </div>
                </>
            )}
        </div>
    );
};
